/**
 * Заголовки авторизации workflow для запросов вне axios (sync XHR upload вложений).
 *
 * Дублирует логику request interceptor: `X-CSRF-TOKEN`, `X-AUTH-TOKEN` из cookie/localStorage.
 *
 * @see dev/WUI-293.md — устранение HTTP 403 на `POST /platform/upload`
 */
import Cookies from 'universal-cookie'

const cookies = new Cookies()

/**
 * Устанавливает CSRF и auth-токен через переданный callback (например `xhr.setRequestHeader`).
 */
export function applyWorkflowAuthHeaders(
  setHeader: (name: string, value: string) => void,
): void {
  const csrfToken = cookies.get('CSRF-TOKEN')
  if (csrfToken) {
    setHeader('X-CSRF-TOKEN', String(csrfToken))
  }

  const tokenFromStorage = localStorage.getItem('auth_token')
  if (tokenFromStorage) {
    setHeader('X-AUTH-TOKEN', tokenFromStorage)
    return
  }

  const tokenFromCookies = cookies.get('X-AUTH-TOKEN')
  if (tokenFromCookies) {
    setHeader('X-AUTH-TOKEN', String(tokenFromCookies))
  }
}

/**
 * Базовый URL API workflow (`/api` в dev, иначе `VITE_API_BASE_URL`).
 * Сейчас используется в `getPlatformUploadUrl`; единая точка для sync XHR к platform API.
 */
export function getPlatformApiBaseUrl(): string {
  return import.meta.env.DEV
    ? '/api'
    : import.meta.env.VITE_API_BASE_URL || 'http://localhost:1080/workflow-web-services/api'
}

/** Абсолютный URL `POST /platform/upload` (dev: `/api`, prod: `VITE_API_BASE_URL`). */
export function getPlatformUploadUrl(): string {
  return `${getPlatformApiBaseUrl()}/platform/upload`
}
